// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../Api.js";
import ResponseChecker from "../Middlewares/ResponseChecker.js";
import { defaultMessages } from "../enums/responseMessages.js";
import Endpoints from "../Endpoints/index.js";

// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

// ## AuxiliaryCoolingEquipment Get
/**
 *
 * @param {{params: object, query: { page: number, limit: number, search: string }}} option
 *
 * @returns
 */
export const GetAll = async (option) => {
  const response = await $api.get(
    Endpoints.AuxiliaryCoolingEquipment.GetAll(option)
  );

  const checker = await ResponseChecker(defaultMessages, response);

  return checker;
};
// ## AuxiliaryCoolingEquipment Create
/**
 *
 * @param {{ "name": "string"}} form
 *
 * @returns
 */
export const Create = async (form) => {
  const response = await $api.post(
    Endpoints.AuxiliaryCoolingEquipment.Create(),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## AuxiliaryCoolingEquipment Get ById
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetById = async (option) => {
  const response = await $api.get(
    Endpoints.AuxiliaryCoolingEquipment.GetById(option)
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## AuxiliaryCoolingEquipment Update
/**
 *
 * @param  {{ "name": "string"}} form
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Update = async (form, option) => {
  const response = await $api.put(
    Endpoints.AuxiliaryCoolingEquipment.Update(option),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## AuxiliaryCoolingEquipment Delete
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Delete = async (option) => {
  const response = await $api.delete(
    Endpoints.AuxiliaryCoolingEquipment.Delete(option)
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export default {
  GetAll,
  Create,
  GetById,
  Update,
  Delete,
};
